import clsx from "clsx";
import React from "react";

interface LoadingProps {
  spin?: boolean;
}

export const Spin: React.FC<LoadingProps> = (props) => {
  const { spin, children } = props;
  return (
    <div
      className={clsx({ "loader-wrapper": spin })}
      style={{ height: "100%", width: "100%" }}
    >
      <div className={clsx("loader", { loading: spin })}>
        {!spin && children}
      </div>
    </div>
  );
};
